import { render, staticRenderFns } from "./addToCartFromPremium.vue?vue&type=template&id=d8f9c014&lang=pug"
import script from "./addToCartFromPremium.vue?vue&type=script&lang=js"
export * from "./addToCartFromPremium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports